import React, { FC } from "react";

import { bem } from "@react-md/utils";
import AntdPagination, { PaginationProps as AntdPaginationProps } from "antd/es/pagination";
import cn from "classnames";

const block = bem("mmc-pagination");

export interface PaginationProps extends AntdPaginationProps {}

const Pagination: FC<PaginationProps> = ({ className, ...props }) => {
  return <AntdPagination className={cn(block(), className)} {...props} />;
};

export default Pagination;
